"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePreviousOrder = void 0;

var _reactQuery = require("react-query");

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _useLogout = require("./useLogout");

var _useAuthenticated = require("./useAuthenticated");

var _api = require("../api");

var _types = require("../types");

var _settings = require("../../settings");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var usePreviousOrder = function usePreviousOrder(_a) {
  var storeId = _a.storeId,
      serviceMethod = _a.serviceMethod;

  var _b;

  var logout = (0, _useLogout.useLogout)()[0];
  var isAuthenticated = (0, _useAuthenticated.useAuthenticated)();
  var settings = (0, _settings.useSettings)().data;
  var isReorderModalEnabled = (_b = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _b === void 0 ? void 0 : _b.REORDER;
  return (0, _reactQuery.useQuery)(_types.QueryKeys.PreviousOrder, function () {
    return (0, _api.fetchPreviousOrder)({
      storeId: storeId,
      serviceMethod: serviceMethod
    });
  }, {
    enabled: !!(isAuthenticated && storeId && serviceMethod && isReorderModalEnabled),
    onError: function onError(error) {
      var _a, _b;

      if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        logout();
      }

      var _c = ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) || {},
          text = _c.text,
          code = _c.code;

      Sentry.getCurrentHub().withScope(function (scope) {
        var _a;

        scope.setExtras({
          exceptionMessage: text,
          exceptionCode: code || ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status),
          hook: 'usePreviousOrder'
        });
        scope.setTags({
          "package": "account"
          /* account */
          ,
          api: 'previousorder'
        });
        Sentry.getCurrentHub().captureException(new Error(text));
      });
    }
  });
};

exports.usePreviousOrder = usePreviousOrder;